export default {
  // CTA conversions insights
  cta_click_new_notebook: "cta_click_new_notebook",
  cta_click_get_edit_access: "cta_click_get_edit_access",
  cta_click_choose_template: "cta_click_choose_template",
  cta_footer_choose_template: "cta_footer_choose_template",
  cta_explore_in_notebook: "cta_explore_in_notebook",
  cta_download_dataset: "cta_download_dataset",
  cta_create_notebook_banner: "cta_create_notebook_banner",
  public_notebook_edit_data: "public_notebook_edit_data",
  // Dataset insights
  dataset_search_query: "dataset_search_query",
  dataset_explore_in_notebook: "dataset_explore_in_notebook",
  dataset_download: "dataset_download",
  dataset_share_action: "dataset_share_action",
  // Notebook insights
  notebook_edit_chunk: "notebook_edit_chunk",
  notebook_from_template: "notebook_from_template",
  notebook_action: "notebook_action",
  notebook_share_action: "notebook_share_action",
  notebook_sample_group_action: "notebook_sample_group_action",
};
